import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moJob from './store';
import PDF from '../component/pdf';
import Title from '../component/title';
import HeadPdf from '../component/head-pdf';
import FootPdf from '../component/foot-pdf';
import moIndex from '../store/index';
import Table from './table';
import TablePDF from './table-pdf';
import Desc from './desc';
import StaticPage from '../component/static-page';

interface IProps {}
interface IState {}

const HotJobPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { lists, list1 } = moJob;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="hot-job">
      <StaticPage
        url="https://file.smartsalary.cn/index-pdf/08.png"
        head={true}
        showuuid={false}
        onetitle="人力资源核心指标"
        twotitle={moIndex.industry.name}/>
      <PDF>
        <section className="hot-job_1515">
          <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
          <section className="content-1515">
            <section className="title-1515">
              <Title tag="近12个月" title="热门岗位及薪酬数据 — 一线城市" bigTitle={industry.name} />
            </section>

            <section className="hot-job_1616">
              <Desc />
              <Table list={list1} />
            </section>
          </section>
          <FootPdf />
        </section>
      </PDF>

      {lists.map((arr: any, index: number) => (
        <TablePDF key={index} list={arr} />
      ))}
    </section>
  );
};

export default observer(HotJobPDF);
